import React from 'react';

import Layout from '../components/Layout';
import Hero from '../views/Hero';
import CoverPlayable from '../components/CoverPlayable';
import SimpleButton from '../components/SimpleButton';
import Section from '../components/Section';
import Content from '../components/Content';

import Videos from '../views/Videos';
import Photos from '../views/Photos';
import Projects from '../views/Projects';
import Quotation from '../views/Quotation';
import SimpleHelmet from '../components/SimpleHelmet';

import styles from './Project.module.scss';

export const ProjectTemplate = ({
  title,
  coverImage,
  subHeading,
  spotifyPlaylist,
  digitalLink,
  cdLink,
  vinyleLink,
  content,
  blackText,
  photos,
  videos,
  quotes,
  projects,
  lightCoverImage
}) => {
  return (
    <>
      <Hero image={coverImage} light={lightCoverImage}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <h1 className={styles.headerTitle}>{title}</h1>
            <div className={styles.headerSubheading}>{subHeading}</div>
            {(digitalLink || cdLink || vinyleLink) && (
              <div className={styles.headerAvailable}>Available on :</div>
            )}
            <div className={styles.headerButtons}>
              {digitalLink && (
                <a href={digitalLink} target="_blank" rel="noopener noreferrer">
                  <SimpleButton title="DIGITAL" />
                </a>
              )}
              {cdLink && (
                <a href={cdLink} target="_blank" rel="noopener noreferrer">
                  <SimpleButton title="CD" />
                </a>
              )}
              {vinyleLink && (
                <a href={vinyleLink} target="_blank" rel="noopener noreferrer">
                  <SimpleButton title="VINYLE" />
                </a>
              )}
            </div>
          </div>
          <div className={styles.headerRight}>
            <CoverPlayable img={coverImage} spotifyPlaylist={spotifyPlaylist} />
          </div>
        </div>
      </Hero>
      <Section light className={styles.content} title={`${title}`}>
        <div className={styles.contentWrapper}>
          {blackText && blackText !== '' && (
            <div className={styles.contentBlack}>
              <Content html={blackText} />
            </div>
          )}
          <div className={styles.contentLeft}>
            <Content html={content} />
          </div>
        </div>
      </Section>
      <Quotation quotes={quotes} />
      <Photos items={photos} title="photos" />
      <Videos items={videos} title="videos" />
      <Projects projects={projects} />
    </>
  );
};

const Project = ({ data }) => {
  const { frontmatter, html, fields } = data.markdownRemark;
  const projects = data.projects.edges.map(({ node }) => {
    const { title, coverImage } = node.frontmatter;
    return {
      title,
      coverImage,
      slug: node.fields.slug
    };
  });
  return (
    <Layout absoluteMenu>
      <SimpleHelmet
        seoTitle={frontmatter.title}
        seoDescription={frontmatter.seoDescription}
        seoUrl={fields.slug}
        seoImage={frontmatter.seoImage}
      />
      <ProjectTemplate
        title={frontmatter.title}
        coverImage={frontmatter.coverImage}
        subHeading={frontmatter.subHeading}
        spotifyPlaylist={frontmatter.spotifyPlaylist}
        cdLink={frontmatter.cdLink}
        digitalLink={frontmatter.digitalLink}
        vinyleLink={frontmatter.vinyleLink}
        content={html}
        blackText={fields.blackText}
        quotes={frontmatter.quotes}
        videos={frontmatter.videos}
        photos={frontmatter.photos}
        projects={projects}
        lightCoverImage={frontmatter.lightCoverImage}
      />
    </Layout>
  );
};

Project.propTypes = {};

export default Project;

export const pageQuery = graphql`
  query ProjectTemplate($id: String) {
    markdownRemark(id: { eq: $id }) {
      html
      fields {
        blackText
        slug
      }
      frontmatter {
        title
        seoDescription
        coverImage {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        seoImage: coverImage {
          childImageSharp {
            fixed(width: 600) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        lightCoverImage
        subHeading
        spotifyPlaylist
        digitalLink
        cdLink
        vinyleLink
        photos {
          title
          image {
            childImageSharp {
              fluid(maxWidth: 300) {
                ...GatsbyImageSharpFluid
              }
            }
            publicURL
          }
        }
        videos {
          title
          youtubeId
        }
        quotes {
          quote
          description
          author
        }
      }
    }
    projects: allMarkdownRemark(
      limit: 5
      filter: {
        fileAbsolutePath: { regex: "/content/projects/.*\\\\.md$/" }
        id: { ne: $id }
      }
      sort: { fields: frontmatter___date, order: DESC }
    ) {
      edges {
        node {
          frontmatter {
            title
            coverImage {
              childImageSharp {
                fluid(maxWidth: 300) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
            slug
          }
          id
          html
        }
      }
    }
  }
`;
